import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from "app/service/authentication.service";

@Component({
  selector: 'app-admin-signin',
  templateUrl: './admin-signin.component.html',
  styleUrls: ['./admin-signin.component.css']
})
export class AdminSigninComponent  {
    model: any = {};
    loading = false;
    error = '';

    constructor(
        public router: Router,
        public authenticationService: AuthenticationService) { }

    ngOnInit() {
        // reset login status
        this.authenticationService.signoutAdmin();
    }

    signin() {
        this.loading = true;
        this.authenticationService.signinAdmin(this.model.kullaniciAdi, this.model.password).subscribe(data =>
          {
                localStorage.setItem('currentUser', JSON.stringify({ name: data.body.userName , token: data.body.token , pass: data.body.pass , kullaniciPk: data.body.kullaniciPk , tokenDate: new Date().setTime(new Date().getTime() + (1000 * 60 * 60 * 10)) }));
                this.router.navigate(['/']);
              } ,
              error => {
                this.error = 'Kullanıcı adı veya şifre hatalı.';
                this.loading = false;
              },
              () => {
                this.authenticationService.setAdminRenewalTimer();
              }
            );
    }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin/admin-signin/admin-signin.component.ts